import { Base } from '../Base';

export abstract class Sets extends Base
{
	
}